var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"96","height":"96","fill":"currentColor","viewBox":"0 0 96 96"}},[_c('path',{attrs:{"d":"M42.009 93 1 60.784l11.66-15.09 25.183 19.783L79.404 5 95 15.894 42.009 93Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }